// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'report.page.title.payables_ageing_report': 'Accounts Payables Ageing Report',

    'report.label.vendor': 'Vendor',
    'report.label.customer': 'Customer',
    'report.label.zero_to_thirty': '0 - 30 Days',
    'report.label.thirty_one_to_sixty': '31 - 60 Days',
    'report.label.sixty_one_to_ninety': '61 - 90 Days',
    'report.label.ninety_plus': '90+ Days',
    'report.label.total': 'Total',
    'report.label.grand_total': 'Grand Total',

    'report.message.no_expenses': 'No expense transactions have been recorded as yet',
};
